import Button from '@/common/components/base/button/Button';
import MainModal from '@/common/components/base/modal/Modal.tsx';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography.tsx';
import BaseCheckBox from '@/common/components/BaseCheckbox/BaseCheckBox';
import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { useEducationParams } from '../../hooks/useEducationParams';
import { getCategoriesListQueryOptions } from '../../queries/getCategoriesList/getCategoriesListQueryOptions';
import {
  CategoryFilterModalProps,
  SelectedCategory,
} from '../../types/Education.type';

export default function CategoryFilterModal({
  open,
  closeModal,
  onApply,
}: CategoryFilterModalProps) {
  const {
    selectedCategories: appliedCategories,
    setCategories,
    clearCategories,
  } = useEducationParams();
  const [selectedCategories, setSelectedCategories] = useState<
    SelectedCategory[]
  >([]);

  const { data: categoriesData, isLoading } = useQuery(
    getCategoriesListQueryOptions(),
  );
  const categories = categoriesData || [];

  useEffect(() => {
    if (open) {
      setSelectedCategories(appliedCategories);
    }
  }, [open, appliedCategories]);

  const toggleSelection = (category: { id: number; title: string }) => {
    setSelectedCategories((prev) =>
      prev.some((item) => item.id === category.id)
        ? prev.filter((item) => item.id !== category.id)
        : [...prev, { id: category.id, title: category.title }],
    );
  };

  const handleConfirm = () => {
    setCategories(selectedCategories);
    onApply?.(selectedCategories);
    closeModal();
  };

  const handleDeleteAllCategories = () => {
    setSelectedCategories([]);
    clearCategories();
    onApply?.([]);
    closeModal();
  };

  return (
    <MainModal open={open} closeModal={closeModal}>
      <Flex flexDirection="column" gap={6} p={2}>
        <TitleDescription color="black-1" textStyle="h2">
          دسته‌بندی
        </TitleDescription>

        <Box
          className={css({
            display: 'flex',
            flexDirection: 'column',
            my: '32px',
            gap: 2,
          })}
        >
          {categories?.map((category) => {
            const isChecked = selectedCategories.some(
              (item) => item.id === category.id,
            );

            return (
              <Flex
                key={category.id}
                alignItems="center"
                py="10px"
                gap={12}
                cursor="pointer"
                onClick={() => toggleSelection(category)}
              >
                <Box pointerEvents="none">
                  <BaseCheckBox
                    id={category.id.toString()}
                    checked={isChecked}
                  />
                </Box>
                <Typography color="black" textStyle="b1">
                  {category.title}
                </Typography>
              </Flex>
            );
          })}
        </Box>

        <Box
          display="flex"
          position="sticky"
          gap={16}
          bottom="0"
          backgroundColor="white"
          pt={4}
          borderTop="1px solid"
          borderColor="gray-4"
        >
          <Button
            width="100%"
            color="common"
            variant="outlined"
            onClick={handleDeleteAllCategories}
            disabled={isLoading}
          >
            حذف همه
          </Button>
          <Button width="100%" onClick={handleConfirm} disabled={isLoading}>
            اعمال
          </Button>
        </Box>
      </Flex>
    </MainModal>
  );
}
